<template>
  <!-- 按钮二次封装
      @author: liuguisheng
      @date: 2019-9-13
  -->
  <div class="form-item_input form-item_button"
       :style="{'padding-left': paddingLeft}">
    <el-button :type="buttonType"
               :plain="!buttonBack"
               :size="buttonSize">
      <span style="display: inline-block" :style="{minWidth: width }">
        {{buttonText}}
      </span>
    </el-button>
  </div>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixFormItemTemplateChild 表单项子级混入
 */
import { mixFormItemTemplateChild } from "@/mixins/form_item/mix_form_item_template_child.js";

export default {
  mixins: [ mixFormItemTemplateChild ]
}

</script>


// WEBPACK FOOTER //
// src/components/form_item/FormItemButton.vue